/* eslint-disable react/jsx-pascal-case */
import axios from "../../../axios";
import React, { useState } from "react";
import moment from "moment";
import { IP } from "../../../internalServer";
import { useSelector } from "react-redux";
import ThreeDot_Post_Popup from "./ThreeDot_Post_Popup";
import EditComment from "./EditComment";
import DeleteComme from "./DeleteComme";
import "./feedDetail.css";
import { IconButton, Tooltip } from "@mui/material";
import { shortenParagraph } from "../../../utils/Engagement";
import { Pencil, Trash2 } from "lucide-react";
import { Close, DeleteOutline, Edit } from "@mui/icons-material";
// css comes in feed Details

const CommentList = ({
  setIsCommented,
  isCommented,
  commentData,
  comment_id,
  post_id,
  setComments,
  setIsInProgress,
  isInProgress,
  currentCommentNumber,
  setCurrentCommentNumber,
  filter,
  setFilter,
  post,
  getPostComme
}) => {
  const { page } = filter;
  // let user_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const user_id = useSelector((state) => state.user.currentUser.id);
  const [postThreedot, setPostThreedot] = useState(false);


  function formatDate(dateString) {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const options = { day: "2-digit", month: "short" };

    if (date.toDateString() === today.toDateString()) {
      return "Today";
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else {
      return date.toLocaleDateString("en-GB", options);
    }
  }

  function formatTime(timeString) {
    const time = new Date(timeString);
    let hours = time.getHours();
    const minutes = time.getMinutes();
    const period = hours >= 12 ? "pm" : "am";

    hours = hours % 12 || 12;

    const paddedMinutes = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${paddedMinutes} ${period}`;
  }
  function isUpdatedAfterCreated(createdAt, updatedAt) {
    // Convert the date strings into Date objects
    const createdDate = new Date(createdAt);
    const updatedDate = new Date(updatedAt);

    // Compare the two dates
    return updatedDate > createdDate;
  }

  const [clickEditComment, setClickEditComment] = useState(false);
  const [comment, setComment] = useState(false);
  const [edited, setEdited] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [deleteClicked, setDeleteClicked] = useState(false);


  return !post?.isDeleted && commentData ? (
    <div
      className="mb-2 d-flex justify-content-between comment-sec p-1 w-full"
      onClick={() => (postThreedot ? setPostThreedot(!postThreedot) : "")}
    >
      <div
        className="w-full d-flex gap-2 align-items-start bg-slate-100 p-2 
      "
      >
        {commentData?.user_id?.user_type === "Teacher" ? (
          <img
            src={
              commentData?.user_id?.profile_picture
                ? IP + commentData?.user_id?.profile_picture.replace(/^\./, "")
                : commentData?.user_id?.gender === "M"
                  ? "/images/Teacher_Male.jpg"
                  : commentData?.user_id?.gender === "F"
                    ? "/images/Teacher_Female.png"
                    : "/images/default image.png"
            }
            alt="icon"
            className=""
            style={{
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              cursor: "pointer",
            }}
            key={commentData?.user_id?.avatar_profile}
            onError={(e) => {
              if (commentData?.user_id?.gender === "M") {
                e.target.src = "/images/Teacher_Male.jpg";
              } else if (commentData?.user_id?.gender === "F") {
                e.target.src = "/images/Teacher_Female.png";
              } else {
                e.target.src = "/images/default image.png";
              }
            }}
          />
        ) : (
          <img
            src={
              commentData?.user_id?.profile_picture
                ? IP + commentData?.user_id?.profile_picture.replace(/^\./, "")
                : commentData?.user_id?.gender === "M"
                  ? commentData?.user_id?.avatar_profile
                    ? "/images/Boys/" +
                    commentData?.user_id?.avatar_profile +
                    ".webp"
                    : "/images/Student_boy_pic.png"
                  : commentData?.user_id?.gender === "F"
                    ? commentData?.user_id?.avatar_profile
                      ? "/images/Girls/" +
                      commentData?.user_id?.avatar_profile +
                      ".webp"
                      : "/images/Student_girl_pic.png"
                    : "/images/default image.png"
            }
            alt="icon"
            className=""
            style={{
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              cursor: "pointer",
            }}
            key={commentData?.user_id?.avatar_profile}
            onError={(e) => {
              if (commentData?.user_id?.gender === "M") {
                e.target.src = commentData?.user_id?.avatar_profile
                  ? "/images/Boys/" +
                  commentData?.user_id?.avatar_profile +
                  ".webp"
                  : "/images/Student_boy_pic.png";
              } else if (commentData?.user_id?.gender === "F") {
                e.target.src = commentData?.user_id?.avatar_profile
                  ? "/images/Girls/" +
                  commentData?.user_id?.avatar_profile +
                  ".webp"
                  : "/images/Student_girl_pic.png";
              } else {
                e.target.src = "/images/default image.png";
              }
            }}
          />
        )}

        <div className="d-flex flex-column w-100">
          <div className="flex items-center mb-1">
            {commentData?.user_id?.user_type === "Teacher" && (
              <img
                className="mr-1 teacher_icon"
                src="/images/teacher_icon.svg"
                alt=""
              />
            )}
            <span className="write_user_name">
              {commentData?.user_id?.name} &nbsp;
            </span>
            {commentData?.user_id?.user_type === "Student" && (
              <span className="class_time">
                {commentData?.user_id?.standard?.name} class |&nbsp;
              </span>
            )}
            {/* <div>{commentData.isDeleted}</div> */}
            {/* <div>{commentData.user_id.id}</div> */}

            <span className="class_time">
              {/* {moment(timeHelper(commentData?.created_at)).calendar({
                sameDay: "h:mm a",
                lastDay: "[Yesterday]",
                lastWeek: "DD MMM YYYY ",
                sameElse: "DD MMM YYYY",
              })} */}
              {formatDate(commentData?.created_at)} |&nbsp;
            </span>

            <span className="class_time">
              {formatTime(commentData?.created_at)}
            </span>
            {commentData?.isDeleted ? (
              <span className="ml-2 class_time" style={{ color: "red" }}>
                *Deleted
              </span>
            ) : (
              isUpdatedAfterCreated(
                commentData?.created_at,
                commentData?.updated_at
              ) && <span className="ml-2 class_time">Edited</span>
            )}
            {/* {commentData?.created_at} */}
          </div>
          {!clickEditComment && (
            <span className="post_comment comments-text w-[700px]">
              {commentData?.comment}
            </span>
          )}

          {clickEditComment && (
            <EditComment
              setEdited={setEdited}
              commentData={commentData}
              setComments={setComments}
              setIsCommented={setIsCommented}
              setClickEditComment={setClickEditComment}
              setIsInProgress={setIsInProgress}
              isInProgress={isInProgress}
              post_id={post_id}
              isCommented={isCommented}
              getPostComme={getPostComme}
            />
          )}
        </div>
      </div>

      {commentData?.user_id?.id === user_id
        ? !commentData?.isDeleted &&
        !post?.isDeleted &&
        !clickEditComment && (
          <div className="flex gap-[10px] items-center">
            <IconButton
              size="small"
              color="primary"
              onClick={() => {
                setPostThreedot(false);
                setClickEditComment((prev) => !prev);
              }}
            >
              <Edit fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              color="error"
              onClick={() => setDeleteClicked((prev) => !prev)}
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          </div>
        )
        : null}

      {/* {postThreedot && (
        // <div style={{ zIndex: 10 }}>

        <ThreeDot_Post_Popup
          post_id={post_id}
          comment_id={comment_id}
          user_id={user_id}
          setPostThreedot={setPostThreedot}
          postThreedot={postThreedot}
          setIsInProgress={setIsInProgress}
          setIsCommented={setIsCommented}
          isInProgress={isInProgress}
          commentData={commentData}
          isCommented={isCommented}
          setFilter={setFilter}
          filter={filter}
          setComments={setComments}
          setCurrentCommentNumber={setCurrentCommentNumber}
          currentCommentNumber={currentCommentNumber}
          setClickEditComment={setClickEditComment}
          setDeleteClicked={setDeleteClicked}
        />
      )} */}

      {deleteClicked && (
        <DeleteComme
          post_id={post_id}
          comment_id={comment_id}
          user_id={user_id}
          setPostThreedot={setPostThreedot}
          postThreedot={postThreedot}
          setIsInProgress={setIsInProgress}
          setIsCommented={setIsCommented}
          isInProgress={isInProgress}
          commentData={commentData}
          isCommented={isCommented}
          setFilter={setFilter}
          filter={filter}
          setComments={setComments}
          setCurrentCommentNumber={setCurrentCommentNumber}
          currentCommentNumber={currentCommentNumber}
          setDelet={setDeleteClicked}
          getPostComme={getPostComme}
        />
      )}
      {/* {commentData?.user_id?.id === user_id && (
        <div
          className="comment_delete_icon d-flex align-items-center justify-content-center"
          onClick={DeleteComment}
        >
          <img src="/images/delete_blue_icon.svg" alt="" />
        </div>
      )} */}
    </div>
  ) : (
    <></>
  );
};
export default CommentList;
